import _ from "lodash";
import { path } from "../../api";
import * as actions from "../../utils/actions";
import { restClient } from "../../utils/restClient";

const initialState = {
  templates: [],
  template: null,
};

export default {
  namespaced: true,
  name: "emailTemplate",
  state: _.cloneDeep(initialState),
  mutations: {
    [actions.GET_EMAIL_TEMPLATES](state, payload = []) {
      state.templates = payload;
    },
    [actions.GET_EMAIL_TEMPLATE](state, payload = null) {
      state.template = payload;
    },
    [actions.UPDATE_EMAIL_TEMPLATE](state, payload = null) {
      state.template = payload;
    },
    [actions.RESET_EMAIL_TEMPLATE_FORM](state) {
      state.template = null;
    },
  },
  actions: {
    async fetchEmailTemplates({ commit }, payload = {}) {
      // eslint-disable-next-line no-async-promise-executor
      return new Promise(async (resolve, reject) => {
        try {
          const response = await restClient(
            path.admin.emailTemplates.base,
            "GET",
            null,
            payload
          );
          commit(actions.GET_EMAIL_TEMPLATES, response.data.data);
          resolve(response);
        } catch (error) {
          commit(actions.GET_EMAIL_TEMPLATES, []);
          reject(error);
        }
      });
    },
    async fetchEmailTemplate({ commit }, payload) {
      // eslint-disable-next-line no-async-promise-executor
      return new Promise(async (resolve, reject) => {
        try {
          const { data } = await restClient(
            path.admin.emailTemplates.single(payload),
            "GET"
          );
          commit(actions.GET_EMAIL_TEMPLATE, data);
          resolve(data);
        } catch (error) {
          commit(actions.GET_EMAIL_TEMPLATE, null);
          reject(error);
        }
      });
    },
    async updateEmailTemplate({ commit }, payload) {
      // eslint-disable-next-line no-async-promise-executor
      return new Promise(async (resolve, reject) => {
        try {
          const { formData, id } = payload;
          const response = await restClient(
            path.admin.emailTemplates.single(id),
            "PUT",
            formData
          );
          commit(actions.UPDATE_EMAIL_TEMPLATE, response?.data);
          resolve(response);
        } catch (error) {
          reject(error);
        }
      });
    },
    resetForm({ commit }) {
      commit(actions.RESET_EMAIL_TEMPLATE_FORM);
    },
  },
};
